"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.$search = void 0;
var _oldHttpClient = require("../../apiClient/oldHttpClient");
var $search = exports.$search = function $search() {
  var searchParameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var debugParameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var {
    query,
    filters,
    page,
    subFilters,
    limit,
    highlight,
    _feed,
    _users,
    fromDate,
    toDate
  } = searchParameters;
  var body = {};
  if (query && query !== '') {
    body.q = query;
  }
  if (filters && filters.length > 0) {
    body.filters = filters;
    if (subFilters) {
      Object.keys(subFilters).forEach(subFilter => {
        body[subFilter] = subFilters[subFilter];
      });
    }
  }
  if (page) {
    body.page = page;
  }
  if (limit) {
    body.limit = limit;
  }
  if (highlight) {
    body.highlight = highlight;
  }
  if (_feed) {
    body._feed = _feed;
  }
  if (_users && _users.length > 0) {
    body._users = _users;
  }
  if (fromDate) {
    body.fromDate = fromDate;
  }
  if (toDate) {
    body.toDate = toDate;
  }
  var {
    useExperimentalSearch,
    showScore,
    showRequest
  } = debugParameters;
  if (useExperimentalSearch) {
    body.useExperimentalSearch = useExperimentalSearch;
  }
  if (showScore) {
    body.showScore = showScore;
  }
  if (showRequest) {
    body.showRequest = showRequest;
  }
  return (0, _oldHttpClient.apiClient)({
    method: 'post',
    url: '/search',
    body
  });
};